{% block swag_migration_tab_card_item %}
    <div class="swag-migration-tab-card-item">
        <div v-if="active">
            <slot>
                {% block swag_migration_tab_card_item_slot %}{% endblock %}
            </slot>
        </div>
    </div>
{% endblock %}
